// FAQSection.js
import React, { useState } from 'react';
import '../App.css'; // or wherever your CSS is

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'What is BankRates.io?',
      answer: 'BankRates.io shows you best place to deposit your money. Other sites show sponsors or ads, we show you the best rates.'
    },
    {
      question: 'Why do Credit Unions have better rates?',
      answer: 'Banks are responsible for maxmimizing shareholder value so profits go back to stockholders and owners. Credit Unions are Not for Profit entities and are owned by the members of the Credit Union. Profits are returned to the members in the form of better rates and lower fees. That being said many high rate APY interest accounts from credit unions require you to enroll in direct deposit, log into digital banking, or use your debit card a certain number of times'
    },
    {
      question: 'Why should I sign up for emails?',
      answer: 'We will send you one email per month with the best rates. No BS, just rate changes.'
    },
    {
      question: 'What is the best rate for me?',
      answer: 'If you do not need to access your money for a while, a CD or Bond is a better option. If you need to access your money, a high yield savings account is a great option. If you have a lot of money, a money market account is a great option. If you can risk losing your money, a stock market index fund is historically the best option. A balanced portfolio of all of these options is the best option.'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="faq-container">
      <h2 className="faq-heading">Frequently Asked Questions</h2>
      {faqs.map((faq, index) => (
        <div
          key={index}
          className="faq-item"
          onClick={() => toggleFAQ(index)}
        >
          <h3 className="faq-question">{faq.question}</h3>
          {openIndex === index && (
            <p className="faq-answer">{faq.answer}</p>
          )}
        </div>
      ))}
    </div>
  );
};

export default FAQSection;
